import { PLAYER } from '../data';
import { canLevelUp, calculateLevelUpCost, processLevelUp } from '../utils/gameUtils';


export const getCharacterData = (characterId) => {
  if (!characterId) {
    characterId = PLAYER.team[0];
  }
  const character = PLAYER.characters.find(char => char.uid === characterId);
  return {
    ...character,
    tags: character.tags || [],
    elements: character.elements || [],
    menuItems: [
      { text: "Overview", icon: "BookOpen", active: true },
      { text: "Equipment", icon: "Sword" },
      { text: "Skills", icon: "Star" },
      { text: "Ascension", icon: "Crown" }
    ]
  };
};

export const handleCharacterLevelUp = (character) => {
  if (!canLevelUp(character)) {
    return null;
  }
  return processLevelUp(character);
};

export const getCharacterLevelInfo = (character) => {
  return {
    canLevelUp: canLevelUp(character),
    upgradeCost: calculateLevelUpCost(character.level)
  };
};
